import { persistentAtom } from '@nanostores/persistent'

import type { BillingInterval } from '~/features/billing/types'

export const $currentInterval = persistentAtom<BillingInterval>('billing:interval', 'year', {
  encode: (value) => value,
  decode: (value) => (value === 'month' ? 'month' : 'year')
})
